import * as React from 'react'
import {Box} from "@mui/material";
import { ArrowPercentage } from '@components';

export default function valueColumn(name, label, handleClick) {
	return {
		name, label,
		options: {
			setCellHeaderProps: () => ({ sx: {
					whiteSpace: 'pre-wrap'
			}}),
			customBodyRowRender: (value, rowData) => {
				const prev = rowData[`${name}Prev`]

				return <Box sx={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => handleClick(rowData.groupedID, label)}>
					<ArrowPercentage value={value} prev={prev} useBackground />
				</Box>
			}
		}
	}
}